<!-- Loading bar -->
<fuse-loading-bar></fuse-loading-bar>

<!-- Navigation -->
<!-- TODO: ESTE ES EL LAYOUT POR DEFECTO. HAY QUE LIMPIAR LAYOUTS -->
<fuse-vertical-navigation
    [appearance]="navigationAppearance"
    [mode]="isScreenSmall ? 'over' : 'side'"
    [name]="'mainNavigation'"
    [navigation]="navigation.default"
    [opened]="true"
    class="bg-white dark:bg-gray-900 print:hidden"
>
    <!-- Navigation header hook -->
    <ng-container fuseVerticalNavigationContentHeader>
        <!-- Logo -->
        <div class="flex items-center justify-center h-16 border-b gap-0">
            <div class="flex items-center justify-leftt gap-6 w-full" [class.hidden]="navigationAppearance === 'dense'">
                <ac-button *ngIf="navigationAppearance === 'default'" (click)="toggleNavigationAppearance()" type="icon">
                    <mat-icon [svgIcon]="'heroicons_outline:bars-3'"></mat-icon>
                </ac-button>
                <img
                    *ngIf="navigationAppearance === 'default'"
                    alt="{{ appName }}"
                    class="full-logo h-auto block"
                    [src]="logoUrl"
                    [style.max-width.px]="logoMaxWidth ?? 100"
                />
            </div>
            <div class="flex items-center justify-center w-full">
                <ac-button *ngIf="navigationAppearance === 'dense'" (click)="toggleNavigationAppearance()" type="icon">
                    <mat-icon [svgIcon]="'heroicons_outline:bars-3'"></mat-icon>
                </ac-button>
            </div>
        </div>
    </ng-container>
</fuse-vertical-navigation>

<!-- Wrapper -->
<div class="flex flex-col flex-auto w-full min-w-0">
    <!-- Header -->
    <div
        class="relative flex flex-0 gap-2 items-center w-full h-16 px-4 md:px-6 z-49 shadow dark:shadow-none dark:border-b bg-card dark:bg-transparent print:hidden"
    >
        <div class="flex items-center space-x-2 compact-logo">
            <img
                *ngIf="navigationAppearance === 'dense'"
                alt="{{ appName }}"
                class="w-full h-auto block"
                [src]="logoUrl"
                [style.max-width.px]="logoMaxWidth ?? 90"
            />
        </div>

        <!-- Advertiser + Organization (super-admin) -->
        <div class="flex items-center gap-2 mt-5">
            <mat-form-field
                appearance="outline"
                class="w-45 [&_.mat-mdc-form-field-wrapper]:pb-0 [&_.mat-mdc-form-field-wrapper]:mb-0 [&_.mat-mdc-form-field-flex]:h-9 [&_.mat-mdc-form-field-infix]:py-1"
            >
                <input
                    matInput
                    [placeholder]="'Choose advertiser...' | transloco"
                    [formControl]="searchControl"
                    [matAutocomplete]="auto"
                    (click)="onInputClick()"
                    (focus)="onInputClick()"
                    class="text-sm"
                />
                <mat-icon matPrefix [svgIcon]="'heroicons_outline:folder-open'" class="!w-4 !h-4"></mat-icon>
                <mat-icon
                    matSuffix
                    [svgIcon]="'heroicons_outline:x-mark'"
                    class="!w-4 !h-4 cursor-pointer text-gray-400 hover:text-gray-600"
                    (click)="clearAdvertiserSelection()"
                    *ngIf="searchControl.value"
                    [title]="'Clear selection' | transloco"
                >
                </mat-icon>
                <mat-autocomplete
                    #auto="matAutocomplete"
                    [displayWith]="displayAdvertiser"
                    (optionSelected)="onOptionSelected($event.option.value)"
                >
                    <mat-option *ngFor="let advertiser of filteredOptions | async" [value]="advertiser">
                        <div class="flex flex-col">
                            <span class="font-medium">{{ advertiser.name }}</span>
                            <span class="text-xs text-gray-500 truncate max-w-48">{{ advertiser.description }}</span>
                        </div>
                    </mat-option>
                </mat-autocomplete>
            </mat-form-field>
            <organization-selector></organization-selector>
        </div>

        <ac-button
            *ngIf="isPreProductionEnvironment || isDevelopmentEnvironment"
            mat-button
            type="outline"
            color="danger"
            matTooltip="{{ 'You are in pre-production environment. Changes here will NOT affect production environment.' | transloco }}"
            matTooltipPosition="below"
            class="text-sm font-bold"
        >
            <span *ngIf="isPreProductionEnvironment">{{ "PRE-PRODUCTION" | transloco }}</span>
            <span *ngIf="isDevelopmentEnvironment">{{ "LOCALHOST" | transloco }}</span>
        </ac-button>

        <!-- Components -->
        <div class="flex items-center pl-2 ml-auto space-x-0.5 sm:space-x-2">
            <languages></languages>
            <fuse-fullscreen class="hidden md:block"></fuse-fullscreen>
            <custom-contact-us-button></custom-contact-us-button>
            <changelog-button></changelog-button>
            <!-- <search [appearance]="'bar'"></search> -->
            <!-- <shortcuts></shortcuts>
            <messages></messages>
            <notifications></notifications>
            -->
            <!--<button
                class="lg:hidden"
                mat-icon-button
                (click)="quickChat.toggle()">
                <mat-icon [svgIcon]="'heroicons_outline:chat-bubble-left-right'"></mat-icon>
            </button>-->
            <upload-indicator></upload-indicator>
            <user></user>
        </div>
    </div>

    <!-- Banner de avisos (editable desde /admin), justo debajo de la cabecera. -->
    <notification-banner></notification-banner>

    <!-- Vista de cliente (D-SET32): solo mientras un super admin la tiene puesta. -->
    <client-view-strip></client-view-strip>

    <!-- Content -->
    <div class="flex flex-col flex-auto">
        <!-- *ngIf="true" hack is required here for router-outlet to work correctly.
             Otherwise, layout changes won't be registered and the view won't be updated! -->
        <router-outlet *ngIf="true"></router-outlet>
    </div>

    <!-- Footer -->
    <div
        class="relative flex flex-0 items-center justify-between w-full h-8 px-4 md:px-6 z-49 border-t bg-card dark:bg-transparent print:hidden text-sm"
    >
        <span class="font-medium text-gray-700">{{ appName }} &copy; {{ currentYear }}</span>

        <div class="flex gap-2 text-blue-800 font-medium">
            <a class="hover:text-blue-600" routerLink="/privacy-policy">{{ "Privacy Policies" | transloco }}</a>
            <a class="hover:text-blue-600" routerLink="/legal-notice">{{ "Legal Notice" | transloco }}</a>
        </div>
    </div>
</div>

<!-- Quick chat -->
<!--
<quick-chat #quickChat="quickChat"></quick-chat>
-->
